import React from 'react'
import useTranslation from 'next-translate/useTranslation'
import MultipleCostInvoiceExtraCostRow
  from 'tennders-finance/cost-invoice/components/multiple-cost-invoice/MultipleCostInvoiceExtraCostRow'
import GHref from 'tennders-market/common/components/element/GHref'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPlus } from '@fortawesome/free-solid-svg-icons'

const MultipleCostInvoiceExtraCostsTable = (props) => {
  const {
    extraCostsLines,
    extraCostsErrors,
    onExtraCostsFormChange,
    removeExtraCostsLine,
    onNewAddExtraCostsLine,
    companyId,
    defaultVat,
    reversedVat,
    editMode
  } = props
  const { t } = useTranslation()

  return (
    <>
      <div className="hr"></div>
      <p className="text-uppercase mb-10 ls-1">
        <strong>Extra Costs</strong>
      </p>

      <table
        className="tennders-table-zebra"

      >
        <thead>
          <tr>
            <th />
            <th>#</th>
            <th>Target</th>
            <th>Concept</th>
            <th>Amount</th>
            <th>Vat Percentage</th>
            <th>Total Amount</th>
          </tr>
        </thead>
        <tbody>
          {extraCostsLines.map((extraCost, index) => (
            <MultipleCostInvoiceExtraCostRow
              reversedVat={reversedVat}
              editMode={editMode}
              initialErrors={extraCostsErrors}
              index={index}
              keyIndex={extraCost.id}
              key={extraCost.id}
              companyId={companyId}
              defaultVat={defaultVat}
              onFormChange={onExtraCostsFormChange}
              removeLine={removeExtraCostsLine}
            />
          ))}
        </tbody>
      </table>

      <GHref
        className="btn-border small standard-btn mt-16"
        onClick={() => onNewAddExtraCostsLine()}>
        <span className=" mr-6">
          <FontAwesomeIcon icon={faPlus} />
        </span>
        {t('multiple_cost_invoice:add_extra_cost')}
      </GHref>

    </>
  )
}

export default React.memo(MultipleCostInvoiceExtraCostsTable)
